import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";

function HouseList({
  selectedTown,
  selectedCategory,
  selectedType,
  setSelectedHouse,
  goBack
}) {
  const [houses, setHouses] = useState([]);
  const [searchArea, setSearchArea] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHouses = async () => {
      setLoading(true);

      try {
        const querySnapshot = await getDocs(
          collection(db, "houses")
        );

        const data = querySnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data()
          }))
          .filter(
            (house) =>
              house.town === selectedTown &&
              house.propertyCategory ===
                selectedCategory &&
              house.houseType ===
                selectedType &&
              house.status === "available"
          );

        setHouses(data);
      } catch (error) {
        console.error("Error loading houses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHouses();
  }, [
    selectedTown,
    selectedCategory,
    selectedType
  ]);

  const filteredHouses = houses.filter(
    (house) =>
      (house.area || "")
        .toLowerCase()
        .includes(searchArea.toLowerCase())
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#000000,#1a1a1a,#ffd600)",
        padding: "25px"
      }}
    >
      <button
        onClick={goBack}
        style={{
          padding: "12px 20px",
          border: "none",
          borderRadius: "10px",
          fontWeight: "bold",
          cursor: "pointer"
        }}
      >
        ⬅ Back
      </button>

      <div
        style={{
          maxWidth: "900px",
          margin: "20px auto",
          backgroundColor: "white",
          borderRadius: "25px",
          padding: "30px",
          boxShadow:
            "0 8px 20px rgba(0,0,0,0.25)"
        }}
      >
        <h1
          style={{
            textAlign: "center"
          }}
        >
          🏘️ Available Properties
        </h1>

        <h3
          style={{
            textAlign: "center",
            color: "#555"
          }}
        >
          {selectedTown}
        </h3>

        <h3
          style={{
            textAlign: "center",
            color: "#777"
          }}
        >
          {selectedCategory}
        </h3>

        <h3
          style={{
            textAlign: "center",
            color: "#999"
          }}
        >
          {selectedType}
        </h3>

        <input
          type="text"
          placeholder="🔍 Search area..."
          value={searchArea}
          onChange={(e) =>
            setSearchArea(e.target.value)
          }
          style={{
            width: "100%",
            padding: "14px",
            margin: "25px 0",
            borderRadius: "12px",
            border: "1px solid #ccc",
            fontSize: "16px"
          }}
        />

        {loading ? (
          <div
            style={{
              textAlign: "center",
              padding: "60px 20px"
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                margin: "0 auto 20px",
                border: "6px solid #ddd",
                borderTop: "6px solid #ffd600",
                borderRadius: "50%",
                animation: "spin 1s linear infinite"
              }}
            ></div>

            <h2 style={{ color: "#333" }}>
              Loading properties...
            </h2>

            <p style={{ color: "#666" }}>
              Please wait while we find available
              rentals.
            </p>

            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
        ) : filteredHouses.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "30px"
            }}
          >
            <h3>No properties found.</h3>
          </div>
        ) : (
          filteredHouses.map((house) => (
            <div
              key={house.id}
              onClick={() =>
                setSelectedHouse(house)
              }
              style={{
                background: "#f8f8f8",
                padding: "25px",
                borderRadius: "18px",
                marginBottom: "20px",
                cursor: "pointer",
                boxShadow:
                  "0 3px 12px rgba(0,0,0,0.15)"
              }}
            >
              <h2>{house.plotName}</h2>

              <p>
                <strong>Category:</strong>{" "}
                {house.propertyCategory}
              </p>

              <p>
                <strong>Town:</strong>{" "}
                {house.town}
              </p>

              <p>
                <strong>Area:</strong>{" "}
                {house.area}
              </p>

              <p>
                <strong>Estate:</strong>{" "}
                {house.estate ||
                  "Not Applicable"}
              </p>

              <p>
                <strong>Type:</strong>{" "}
                {house.houseType}
              </p>

              <p>
                <strong>Rent:</strong> KES{" "}
                {house.rent}
              </p>


 <p>
    <strong>Contact:</strong>{" "}
    <a
      href={`tel:${house.contact}`}
      style={{
        color: "#0066cc",
        textDecoration: "none",
        fontWeight: "bold"
      }}
    >
      {house.contact}
    </a>
  </p>
{house.email && (
  <p>
    <strong>Email:</strong> {house.email}
  </p>
)}
              <p
                style={{
                  color: "green",
                  fontWeight: "bold"
                }}
              >
                ✅ Available
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default HouseList;